import { Pipe, PipeTransform } from '@angular/core';

/**
 * Info: checks the key property of usersHeader
 * 		  returns the currentRow value
 * Usage: {{h.key | currentrow: row }}
 * 		  where h.key is the prop of the userHeader obj
 * 		  and row is the singole user retrived.
 * 		  An example can be found in table.component.html rows 18-20
 */
@Pipe({
  name: 'currentRow'
})
export class CurrentRowPipe implements PipeTransform {

	statiCandidatura = [
		'bozza_candidatura',
		'candidatura_confermata',
		'candidatura_rigettata',
		'candidatura_validata'
	];

	statiCasaDiscografica = [
		'bozza_rai',
		'bozza_casaDiscografica',
		'casaDiscografica_confermata'
	];

  transform(value: any,row): any {
    switch (value){
		case "nomeCognome":
			return row["cognome"] + " " + row["nome"];
		case "status":
			return "user_status"+row[value];
		case "stato":
			return this.statiCandidatura[row.stato];
		case "statoCasaDiscografica":
			return this.statiCasaDiscografica[row.stato];
		default:
			return row[value];
	}
  }

}
